import type { LibraryItem } from '../lib/api';

const categoryLabel: Record<LibraryItem['category'], string> = {
  blueprint: 'Make Blueprint',
  n8n: 'n8n Blueprint',
  ebook: 'E-book',
  prompt: 'Prompt',
};

type Props = {
  item: LibraryItem;
  onSelect: (item: LibraryItem) => void;
};

export default function LibraryCard({ item, onSelect }: Props) {
  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-4xl border border-white/10 bg-charcoal transition-colors hover:border-gold/40">
      {item.thumbnailUrl ? (
        <div className="aspect-[16/9] w-full overflow-hidden border-b border-white/5 bg-black">
          <img
            src={item.thumbnailUrl}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover opacity-90 transition-opacity group-hover:opacity-100"
          />
        </div>
      ) : (
        <div className="grain aspect-[16/9] w-full border-b border-white/5 bg-black" />
      )}

      <div className="flex flex-1 flex-col justify-between p-7">
        <div>
          <div className="flex items-center justify-between">
            <span className="font-mono text-[0.65rem] uppercase tracking-label text-gold">
              {categoryLabel[item.category]}
            </span>
            {item.sector && (
              <span className="font-sans text-[0.65rem] uppercase tracking-label text-stone">
                {item.sector}
              </span>
            )}
          </div>

          <h3 className="mt-6 font-display text-2xl font-light leading-tight text-white">
            {item.title}
          </h3>
          {item.description && (
            <p className="mt-3 font-sans text-body text-white/80">
              {item.description}
            </p>
          )}
        </div>

        <div className="mt-8 flex items-center justify-between border-t border-white/5 pt-5">
          <span className="font-sans text-caption text-stone">
            {item.fileType.toUpperCase()} · {(item.sizeBytes / 1024 / 1024).toFixed(1)} MB
          </span>
          <button
            onClick={() => onSelect(item)}
            className="inline-flex items-center gap-2 font-sans text-[0.7rem] uppercase tracking-label text-gold transition-transform group-hover:translate-x-1"
          >
            Download <span aria-hidden>→</span>
          </button>
        </div>
      </div>
    </article>
  );
}
